export let UnsubscribeReason = /*#__PURE__*/function (UnsubscribeReason) {
  UnsubscribeReason["UNKNOWN"] = "unknown";
  UnsubscribeReason["UNWANTED"] = "unwanted";
  UnsubscribeReason["SPAM"] = "spam";
  UnsubscribeReason["NEVER_SIGNED_UP"] = "never_signed_up";
  UnsubscribeReason["OTHER"] = "other";
  return UnsubscribeReason;
}({});